import type { HeartbeatFragment } from "@pathwright/graphql-client/src/generated"

export type HeartbeatDeploy = NonNullable<HeartbeatFragment["deploy"]>

export function notificationMatchesRunningBuild(
  runningBuildId: string,
  notify: HeartbeatDeploy["notify"]
): boolean {
  // null disables notifications; [] targets all stale builds.
  if (!Array.isArray(notify)) return false
  return notify.length === 0 || notify.includes(runningBuildId)
}

export function shouldPromptForDeployRefresh({
  runningBuildId,
  deploy
}: {
  runningBuildId: string | null
  deploy: HeartbeatDeploy | null | undefined
}): boolean {
  if (!runningBuildId || !deploy?.build_id) return false
  // This check also applies to global notifications, preventing refresh loops.
  if (runningBuildId === deploy.build_id) return false
  if (!notificationMatchesRunningBuild(runningBuildId, deploy.notify)) {
    return false
  }
  return true
}
